/**
 * Main App Component
 * Configures routing, React Query, Wallet Connection, and Layout
 * Migrated to use cambrian-ds with Layout component
 */

import '@rainbow-me/rainbowkit/styles.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { WagmiProvider } from 'wagmi';
import { RainbowKitProvider } from '@rainbow-me/rainbowkit';
import { Layout } from './components/Layout';
import { ProjectDetailPageNew } from './pages/ProjectDetailPageNew';
import { KnowledgeGraphPage } from './pages/KnowledgeGraphPage';
import { Erc8004ExplorerPage } from './pages/Erc8004ExplorerPage';
import { GraphQAPage } from './pages/GraphQAPage';
import { config } from './config/wagmi';

// Create Query Client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <WagmiProvider config={config}>
      <QueryClientProvider client={queryClient}>
        <RainbowKitProvider>
          <BrowserRouter>
            <Layout>
              <Routes>
                <Route path="/" element={<KnowledgeGraphPage />} />
                <Route path="/knowledge-graph" element={<KnowledgeGraphPage />} />
                <Route path="/erc8004" element={<Erc8004ExplorerPage />} />
                <Route path="/graph-qa" element={<GraphQAPage />} />
                <Route path="/projects/:symbol" element={<ProjectDetailPageNew />} />
              </Routes>
            </Layout>
          </BrowserRouter>
        </RainbowKitProvider>
      </QueryClientProvider>
    </WagmiProvider>
  );
}

export default App;
